export default "__VITE_ASSET__88e600fd__"